import { getBoundaryLabelCenter } from "@/helpers/masterplan/boundaryLabelCenter";
import { buildQuadraticShapePath } from "@/helpers/masterplan/curvedLotShape";

describe("boundary label center", () => {
  const points = [
    { x: 10, y: 20 },
    { x: 110, y: 20 },
    { x: 110, y: 80 },
    { x: 10, y: 80 },
  ];

  it("positions labels for the compact SVG paths saved by the stage editor", () => {
    expect(getBoundaryLabelCenter(buildQuadraticShapePath(points))).toEqual({
      x: 60,
      y: 50,
    });
  });

  it("keeps curved stage labels at the editor's vertex center", () => {
    const path = buildQuadraticShapePath(points, [
      { edgeIndex: 0, x: 60, y: -80 },
      { edgeIndex: 3, x: -20, y: 50 },
    ]);

    expect(getBoundaryLabelCenter(path)).toEqual({ x: 60, y: 50 });
    expect(getBoundaryLabelCenter(path, points)).toEqual({ x: 60, y: 50 });
  });

  it("continues to support legacy comma-separated boundaries", () => {
    expect(
      getBoundaryLabelCenter("M 10,20 L 110,20 L 110,80 L 10,80 Z")
    ).toEqual({ x: 60, y: 50 });
  });

  it("uses saved vertices when available, matching the creation preview", () => {
    expect(getBoundaryLabelCenter("M0 0L10 0L10 10Z", points)).toEqual({
      x: 60,
      y: 50,
    });
  });

  it("does not create labels for missing or empty boundaries", () => {
    expect(getBoundaryLabelCenter()).toBeNull();
    expect(getBoundaryLabelCenter("")).toBeNull();
  });
});
